import logo from '../assets/sarthi-logo.png';

function BrandLogo({ size = 'md', className = '' }) {
  const pixels = size === 'lg' ? 78 : size === 'sm' ? 40 : 48;

  return (
    <img
      src={logo}
      alt="Sarthi logo"
      className={`brand-logo brand-logo--${size} ${className}`.trim()}
      width={pixels}
      height={pixels}
    />
  );
}

export default BrandLogo;
